import * as React from 'react';

import {
	Wrapper,
	Title,
	Value,
	Header,
	ColName,
	ColValue,
	TotalColValue,
	Row,
	Box,
	List,
	SelectAllCol,
} from './ListBox.styles';

const ListBox = props => {
	const { total, data, isTopItem, onChangeSelectionAll, onChangeCategorySelection } = props;

	return (
		<Wrapper>
			<Box isTopItem={isTopItem}>
				<Title>{total.name}</Title>
				<Value>{total.value}</Value>
			</Box>

			{data && (
				<List>
					<Header>
						<SelectAllCol>
							<input
								type="checkbox"
								id={total.name}
								checked={total.isSelectAll}
								onChange={e => {
									onChangeSelectionAll(total.name, e.target.checked);
								}}
							/>&nbsp; Select All
						</SelectAllCol>
						<TotalColValue>Total</TotalColValue>
					</Header>

					{data.map((dataItem, index) => (
						<Row key={index}>
							<ColName>
								<input
									type="checkbox"
									id={dataItem.name}
									checked={dataItem.isChecked}
									onChange={e => {
										onChangeCategorySelection(dataItem, e.target.checked);
									}}
								/>&nbsp;
								<label htmlFor={dataItem.name}>{dataItem.name}</label>
							</ColName>
							<ColValue>{dataItem.value}</ColValue>
						</Row>
					))}
				</List>
			)}
		</Wrapper>
	);
};

export default ListBox;
